import { Grid, Typography } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'

import maintenanceImgNew from 'app/images/maintenance_img.png'
import { theme } from 'app/theme'

export default function MaintenanceMode() {
    const { t } = useTranslation()

    return (
        <Grid container display="flex" justifyContent="center" alignItems="center" textAlign="center" sx={{ margin: 'auto', padding: { xs: '24px', sm: '0' } }}>
            <Grid size={12} mb="32px">
                <img src={maintenanceImgNew} alt={t('common.alt.maintenance')} style={{ width: '93px', height: '93px' }} />
            </Grid>
            <Grid size={12}>
                <Typography variant="textSize1">{t('maintenance.title')}</Typography>
            </Grid>
            <Grid size={12} mt="16px" mb="16px">
                <Typography variant="textSize3Regular" color={theme.color.grey600}>
                    <Trans i18nKey="maintenance.content" components={{ br: <br /> }} />
                </Typography>
            </Grid>
        </Grid>
    )
}
